import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    storageKey: 'sb-auth-token',
    flowType: 'pkce'
  }
});

// Initialize Supabase connection
export async function initSupabase(): Promise<void> {
  try {
    // Test connection
    const { error } = await supabase.auth.getSession();
    if (error) throw error;
    
    console.log('Supabase connection established');
  } catch (error) {
    console.error('Failed to initialize Supabase:', error);
    throw error;
  }
}